// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lqZzB","select":"styles_select__2g_KH"};